import TableRowExpand from './table-row-expand';

export default TableRowExpand;